import type { TMessages } from '@/types/TMessages'

export const messages = {
  agroservices: {
    title: 'Агросервисы',
    agrocacl: {
      title: 'Агрокалькулятор норм удобрений',
    },
    fgis: {
      title: 'ФГИС Зерно',
    },
    seedingRate: {
      title: 'Агрокалькулятор норм высева',
    },
    agroconsulting: {
      title: 'Агрономическое сопровождение',
    },
    poleExpert: {
      title: 'Поле-Эксперт',
      description:
        'Цифровой помощник агронома и руководителя сельскохозяйственного предприятия. Полный набор сервисов для сбора данных о полях и быстрого принятия агрономических решений',
    },
    poleScouting: {
      title: 'Поле-Скаутинг',
      description: 'Умный скаутинг с расширенной функциональностью поможет по настоящему эффективно отслеживать состояние полей',
    },
    poleDiff: {
      title: 'Поле-Дифвнесение',
      description: 'Оптимизируйте внесение удобрений и управляйте урожайностью каждого поля, не приобретая новую технику',
    },
    farmlandCropValuation: {
      title: 'Оценка земель с/х назначения',
    },
    polePlus: {
      title: 'Поле-Плюс',
      description: 'Цифровой помощник агронома и руководителя сельскохозяйственного предприятия. Вся информация о полях всегда под рукой',
    },
  },
  fertilizersPage: {
    title: 'Удобрения',
  },
  agriculturalProductsPage: {
    title: 'Сельхозтовары',
  },
  fertilizerPage: {
    title: 'Удобрение',
  },
  cartPage: {
    title: 'Корзина',
  },
  userProfilePage: {
    title: 'Профиль',
  },
  harvestSalePage: {
    title: 'Продажа урожая',
  },
  offerRequestsPage: {
    title: 'Запросы цен',
  },
  tenderPublicListPage: {
    title: 'Запросы цен на товары и услуги',
  },
  orderConfirmationPage: {
    title: 'Подтверждение заказа',
  },
  page500: {
    title: '500я',
  },
  page400: {
    title: '404я',
  },
  qrCode: {
    title: 'QR-код оплаты счёта',
  },
  orderDetailPage: {
    title: 'Детали заказа',
  },
  multiCart: {
    title: 'Заказы в корзине',
  },
  impersonationPage: {
    title: 'Имперсонализация',
  },
  indexPage: {
    title: 'поле.рф — площадка для аграриев',
  },
  temporaryBasicAuthPage: {
    title: 'Временная страница авторизации',
  },
  financing: {
    title: 'Кредиты и лизинг',
  },
  feedback: {
    title: 'Обратная связь',
  },
  faq: {
    title: 'Вопросы и ответы',
  },
  infoportal: {
    administration: {
      title: 'Админка инфопортала',
    },
  },
  requisites: {
    title: 'Реквизиты',
  },
  journal: {
    title: 'Журнал',
    news: {
      title: 'Новости',
    },
    publicationArticle: {
      title: 'Публикация: статья',
    },
    publicationNews: {
      title: 'Публикация: новость',
    },
  },
  legalDocuments: {
    title: 'Правовые документы',
  },
  workingConditions: {
    title: 'Специальная оценка условий труда',
  },
  partnerLanding: {
    title: 'Стать партнером Поле.рф',
  },
  syngentaPromoLanding: {
    title: 'Подробности и условия акции «Бонусы от “Сингенты”»',
  },
  vezdehodPromoLanding: {
    title: 'Управление затратами на автопарк для аграриев с помощью топливных карт',
  },
  businessProcess: {
    title: 'Бизнес процессы',
  },
  aboutUs: {
    title: 'Об аграрной площадке поле.рф — отзывы, СМИ, видео',
    description: 'поле.рф создан для того, чтобы аграрии могли закрывать все производственные потребности в режиме одного окна',
  },
} satisfies TMessages
